module.exports = __webpack_public_path__ + "static/featuredProductFront-4b33b7423ca1ab6515aef41973b9ec82.png";